/* @flow */
import TableView from 'components/TableView';
import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import withRouting from 'utils/withRouting';

type TableDetailsLayoutProps = {
  router: Object,
  sort: string,
  order: string,
  list: Object,
  details: Object,
  TableComponent: React.Element,
  DetailsComponent(props: Object): React.Element,
  entity: string,
  height: string,
  IconComponent(props: Object): React.Element,
  ToolbarComponent(props: Object): React.Element
}

function TableDetailsLayout({
  details,
  DetailsComponent,
  download,
  entity,
  height,
  IconComponent,
  list,
  order,
  path,
  router,
  sort,
  TableComponent,
  ToolbarComponent,
}: TableDetailsLayoutProps): React.Element {
  const showDetails = Object.prototype.hasOwnProperty.call(router.location.query, 'did');

  return (
    <Column
      style={{
        flex: 1,
        overflow: 'auto',
      }}
      >
      <Row style={{ flex: 1 }}>
        <TableView
          download={download}
          entity={entity}
          height={height}
          IconComponent={IconComponent}
          list={list}
          order={order}
          router={router}
          sort={sort}
          path={path}
          TableComponent={TableComponent}
          ToolbarComponent={ToolbarComponent}
          />

        {showDetails && (
          <Column style={{ width: '485px' }}>
            <DetailsComponent router={router}>
              {details}
            </DetailsComponent>
          </Column>
        )}
      </Row>
    </Column>
  );
}

export default withRouting(TableDetailsLayout);
